import { setCookie } from '../../../client/cookie/cookieService';

const PRIMARY_REFERRER = 'primary';
const QUICK_LINK_REFERRER = 'quick-link';
const PROPERTY_TYPE_TILE_REFERRER = 'propertytype-tile';
const LOCATION_TILE_REFERRER = 'location-tile';
const COOKIE_FIELD_SRP_REFERRER = 'rca-srp-referrer';

export function referAsPrimary() {
  setCookie(COOKIE_FIELD_SRP_REFERRER, PRIMARY_REFERRER);
}

export function referAsQuickLink() {
  setCookie(COOKIE_FIELD_SRP_REFERRER, QUICK_LINK_REFERRER);
}

export function referAsPropertyTile() {
  setCookie(COOKIE_FIELD_SRP_REFERRER, PROPERTY_TYPE_TILE_REFERRER);
}

export function referAsLocationTile() {
  setCookie(COOKIE_FIELD_SRP_REFERRER, LOCATION_TILE_REFERRER);
}
